/* eslint-disable no-console */
import db from './Database';

/**
 * Deletes the database.
 * @param {object} [options]
 * @param {boolean} [options.preserveAppConfig] - If `true`, preserves `appConfig` in localStorage.
 * @returns {Promise<boolean>} true if the database was successfully deleted, `false` otherwise.
 */
export async function deleteDatabaseAndClearLocalStorage({
  preserveAppConfig = false,
} = {}) {
  return db
    .delete()
    .then(() => {
      console.log('Database successfully deleted');
      let appConfig = null;

      if (preserveAppConfig) {
        appConfig = localStorage.getItem('appConfig');
      }

      localStorage.clear();

      if (preserveAppConfig && appConfig !== null) {
        localStorage.setItem('appConfig', appConfig);
      }

      return true;
    })
    .catch((err) => {
      console.error(`Could not delete database${err}`);
      return false;
    });
}
